import { COLORS } from "../../utils/js/constants";

export default function customModalStyle(theme) {
  return {
    modal: {
      height: "100%",
      width: "100%"
    },
    overlay: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      background: COLORS.black61,
      position: "relative"
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(8.5),
      color: COLORS.lightYellow
    }
  }
}
